"use client";
import { cn } from "@gettactic/helpers";
import { X } from "lucide-react";
import React from "react";

export interface SelectionChipProps {
  label: string;
  /** Leading avatar or glyph. */
  icon?: React.ReactNode;
  onRemove?: () => void;
  disabled?: boolean;
  className?: string;
}

/**
 * A picked person or team as a pill: avatar or glyph, name, and a cross to
 * take it out of the selection.
 */
export const SelectionChip: React.FC<SelectionChipProps> = ({
  label,
  icon,
  onRemove,
  disabled = false,
  className
}) => (
  <span
    className={cn(
      "flex items-center gap-1.5 rounded-full border border-neutral-200 bg-white py-1 pr-1.5 pl-1 text-neutral-700 text-sm",
      className
    )}
  >
    {icon}
    <span className="max-w-[160px] truncate">{label}</span>
    {onRemove ? (
      <button
        type="button"
        aria-label={`Remove ${label}`}
        onClick={onRemove}
        disabled={disabled}
        className="flex h-5 w-5 items-center justify-center rounded-full text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    ) : null}
  </span>
);
